import React, {useState} from 'react';
import './style.css';
import Logo from "../../../assets/images/Vector.png";
import ChatSnap from "../../../assets/images/Group.png";
import AgentSnap from "../../../assets/images/dummy.png";
import { ReactComponent as Dots } from "../../../assets/images/optiondots.svg";
import { ReactComponent as Avatar } from "../../../assets/images/avatar.svg";
import Mic from "../../../assets/images/microphone.png";
import Smiley from "../../../assets/images/smiley.png";
import Clip from "../../../assets/images/clip.png";
import { ReactComponent as Bubble } from "../../../assets/images/bubble.svg";
import Input from '../../common/InputField';

function PreviewThree({ color, gradientOne, gradientTwo, alignment, showAgentPhoto, showLogo, welcomeMessage, placeholderText, bubble }) {
  return (
    <div className="previewThreeWidget">

      <div style={{ margin: "0 auto", borderRadius: '8px', background: "#fff"}}>

        <div className="defaultColor" style={{height: '8vh', padding: '0.75rem', background: color ? color : `linear-gradient(125deg, ${gradientOne} 50%, ${gradientTwo} 75%)`, display: 'flex', justifyContent: 'space-between', alignItems: 'center',  borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}}>
          <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
            {showLogo ? (
              <div>
                <img src={Logo} alt="Logo" style={{ height: '3.6vh'}} />
              </div>
            ) : ('')}
            <div>
              <p className="botMain" style={{fontWeight: 'bold', color: '#fff'}}>TrustChat Bot</p>
              <p className="botSub" style={{lineHeight: '18px', color: '#fff'}}>Support Bot</p>
            </div>
          </div>

          <div>
            <Dots />
          </div>
        </div>

        <div className='previewThreeCenter' style={{height: '28vh', display: 'flex', padding: '1rem 0.75rem', alignItems: 'start'}}>
          <div style={{display: 'flex', gap: '0.4rem', alignItems: 'center'}}>
            {showAgentPhoto ? (
              <img src={AgentSnap} style={{width: '36px', height: '36px'}} alt="agent-image" /> 
              ) : (
                <Avatar />
              )}
            <span className="welcomeMesg" style={{background: '#F1F3F5CC', padding: '0.5rem', borderRadius: '1px 16px 16px 16px'}}>{welcomeMessage}</span>
          </div>
        </div>

        <div className="chat-box-client-container">
          <input
            placeholder={placeholderText}
            className="input-main-message"
            disabled
          />
          <div className="input-icons-div">
            <p>
              <img src={Mic} />
            </p>
            <p>
              <img src={Smiley} />
            </p>
            <p>
              <img src={Clip} />
            </p>
          </div>
        </div>

      </div>

      {bubble ? (
      <div className="defaultColor bubble" style={{ float: alignment, marginTop: '0.75rem', background: color ? color : gradientOne, borderRadius: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={Logo} alt="Logo" style={{ height: '2.6vh'}} />
      </div>
      ) : ( 
        <div className="defaultColor bar" style={{  padding: '0 16px 0 12px', float: alignment, marginTop: '0.75rem', background: color ? color : gradientOne, borderRadius: "28px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={Logo} alt="Logo" style={{ height: '2.6vh'}} /><span className="barText" style={{paddingLeft: '6px', lineHeight: '18px'}}>Chat with us</span>
        </div>
      )}

    </div>
  )
}

export default PreviewThree;